/**
 * <CancelFeesCardSkeleton> — la forme de `<CancelFeesCard>` pendant le calcul des frais.
 *
 * La carte centrée de l'étape 3 : l'intitulé, le montant en grand (`text-3xl`), ce qui le
 * compose, le filet, la date d'engagement. Sur la surface neutre : son rouge ou son vert disent
 * s'il y a des frais, et la page ne le sait pas encore.
 */
import React from "react"

import { Divider } from "../../atoms/Divider"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../Card"

export function CancelFeesCardSkeleton() {
    return (
        <Card p="4">
            <Stack gap="2" align="center">
                <Skeleton textSize="text-sm" width={110} />
                <Skeleton textSize="text-3xl" width={130} />
                <Skeleton textSize="text-sm" width={220} />
                <Divider spacing="1" />
                <Skeleton textSize="text-sm" width={200} />
            </Stack>
        </Card>
    )
}
